import { IconContainer, Text } from './styles';

import CloseIcon from '@mui/icons-material/Close';
import { Alert, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useModule } from 'views/MapView/hooks';



/**
 * 
 * @returns {JSX.Element}
 * @constructor
 * @description Componente de notificação de alerta
 * @example
 * <WarningNotification />
 * @version 1.0.0
 */

const CustomIcon = ({ width = 25, height = 25, fill = '#C24938', style = {}, ...props }) => {
  return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginRight: 8, marginTop: '0px' }} 
        >
          <path
            d="M19.6851 9.99721C19.668 13.6684 17.3359 17.0787 13.8633 18.3327C12.1043 18.9682 10.1807 19.042 8.38196 18.5313C6.65131 18.0376 5.11359 17.0162 3.96172 15.6374C1.57286 12.7719 1.3005 8.56162 3.22974 5.38972C5.13629 2.24619 8.92101 0.560936 12.5355 1.28724C16.1727 2.01922 19.0041 4.98685 19.5886 8.65241C19.6567 9.095 19.6851 9.54894 19.6851 9.99721C19.6907 10.7292 20.8256 10.7292 20.8199 9.99721C20.8029 5.81529 18.153 2.04191 14.2321 0.594981C10.3282 -0.846277 5.74911 0.396382 3.11058 3.61368C1.79416 5.21949 0.999764 7.17711 0.835211 9.24821C0.670657 11.308 1.17566 13.4131 2.2481 15.1835C4.43268 18.7809 8.71674 20.6364 12.8362 19.8023C16.8479 18.9852 20.0823 15.609 20.6951 11.5633C20.7745 11.0413 20.8199 10.5249 20.8199 9.99721C20.8199 9.26523 19.6851 9.26523 19.6851 9.99721Z"
            fill="#C24938"
          />
          <path
            d="M10.2383 5.35936C10.2383 7.3113 10.2383 9.26891 10.2383 11.2209C10.2383 11.4989 10.2383 11.7769 10.2383 12.055C10.2383 12.7869 11.3731 12.7869 11.3731 12.055C11.3731 10.103 11.3731 8.14541 11.3731 6.19347C11.3731 5.91543 11.3731 5.6374 11.3731 5.35936C11.3731 4.63305 10.2383 4.62738 10.2383 5.35936Z"
            fill="#C24938"
          />
          <path
            d="M10.8037 14.5683C10.9196 14.5683 11.0136 14.4743 11.0136 14.3584C11.0136 14.2424 10.9196 14.1484 10.8037 14.1484C10.6877 14.1484 10.5938 14.2424 10.5938 14.3584C10.5938 14.4743 10.6877 14.5683 10.8037 14.5683Z"
            fill="#C24938"
          />
        </svg>
  
  );
};

const WarningNotification = () => {
  const { getElement } = useModule();
  let mapTool = getElement('CPN-MA-MAP');
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false); 
  };

  if (!isOpen) return null; 

  return (
    <>
      {mapTool?.configuracao?.messageWarning?.trim() && (
        <Alert
          severity={undefined} 
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
              style={{
                position: 'absolute',  
                top: '1px',  
                right: '1px',  
                color: '#8F8F8F',  
              
              }} 
            >
              <CloseIcon style={{ fontSize: 18 }} /> 
            </IconButton>
          }
          sx={{
            display: 'flex',
            maxWidth: '600px',
            alignItems: 'center', 
            position: 'fixed', 
            top: 110,  
            left: 'calc((100% - 256px) / 2 + 255px)',  /* Centraliza considerando o componente de 256px */
            transform: 'translateX(-50%)',  
            zIndex: 1000,
            backgroundColor: '#fff6f5',
            color: '#d32f2f', 
            '& .MuiAlert-icon': {
              display: 'none', 
            },
          }}
        >
          <IconContainer>
            <CustomIcon />
            <Text>
              {mapTool?.configuracao?.messageWarning}
            </Text>
          </IconContainer>  
        </Alert>
      )}
    </>
  );
};

export default WarningNotification;

WarningNotification.propTypes = {
  /** Título da notificação */
  title: PropTypes.string.isRequired,
  /** Descrição do aviso */
  description: PropTypes.string,
  /** Elemento que deseja inserir o Tooltip */
  children: PropTypes.any,
  /** Controle de ativação do componente */
  disabled: PropTypes.bool,
};
